import { ref } from 'vue'

const isMemoryUsageDisplayEnabled = ref(false)

export const usePerformanceProfiling = () => {
  return {
    isMemoryUsageDisplayEnabled,
  }
}
